import axios from "axios";

const api = axios.create({
  // baseURL: 'http://localhost:8087',
  baseURL: "https://mais-omni-api-mdstf32ukq-uc.a.run.app",
});

export default api;
